import $ from 'cash-dom'

export default class Video {
  constructor({ $container } = {}) {
    this.$container = $container
    this.hasLoadedEmbed = false

    this.constructElements()

    this.constructEvents()
  }

  static init() {
    const $containers = $(Video.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new Video({ $container: $(elem) })
      })
    }
  }

  constructElements() {
    this.$embed = this.$container.find(Video.selectors.embed)
  }

  constructEvents() {
    this.$container
      .on('click', (e) => this.handleClick({ e }))
  }

  doLoadEmbed() {
    const src = this.$embed.data('src')

    this.$embed.attr('src', src)

    this.$embed.on('load', () => {
      this.hasLoadedEmbed = true

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.$container.addClass(Video.classes.loaded)
        })
      })
    })
  }

  handleClick({ e }) {
    e.preventDefault()

    this.$container.off('click')

    if (!this.hasLoadedEmbed) {
      this.doLoadEmbed()
    }
  }
}

Video.selectors = {
  container: '.js-video',
  embed: '.js-video-embed',
}

Video.classes = {
  loaded: 'o-video--loaded',
}
